import { useEffect, useState } from "react";
import { api } from "../../services/api";
import PendingStatuses from "../../constants/PendingStatus.constant";

const ASSIGNEE_PREFIX = "Changed order assignee to: ";

/**
 * Replace every pending-ish status name in a timeline message with the
 * customer-facing wording.
 */
const humanisePendingStatuses = (value) =>
  PendingStatuses.reduce(
    (text, status) => text.replaceAll(status.split("_").join(" "), "PENDING CONFIRMATION"),
    String(value ?? "")
  );

/**
 * Renders one timeline entry.
 *
 * Assignee changes record the inventory location's short code, so the full name
 * is looked up for display. That lookup previously ran from inside the render
 * body and returned stale state, which re-rendered and fired the request again
 * on a loop; it now runs in an effect keyed on the message.
 */
const TContent = ({ value }) => {
  const [description, setDescription] = useState(() => humanisePendingStatuses(value));

  useEffect(() => {
    const text = String(value ?? "");

    if (!text.includes(ASSIGNEE_PREFIX)) {
      setDescription(humanisePendingStatuses(text));
      return undefined;
    }

    let cancelled = false;
    const assigneeName = text.replace(ASSIGNEE_PREFIX, "");
    setDescription(text);

    api
      .get("inventory-location/find/by-name/", { params: { name: assigneeName } })
      .then((response) => {
        if (cancelled) return;
        const fullName = response.data?.result?.full_name;
        if (fullName) {
          setDescription(text.replace(assigneeName, fullName));
        }
      })
      .catch((error) => {
        console.error("Failed to resolve assignee name:", error);
      });

    return () => {
      cancelled = true;
    };
  }, [value]);

  return <div className="ps-2 pb-1">{description}</div>;
};

export default TContent;
